export const SET_ADDRESS_BEGIN = "SET_ADDRESS_BEGIN";
export const SET_ADDRESS_SUCCESS = "SET_ADDRESS_SUCCESS";
export const SET_ADDRESS_ERROR = "SET_ADDRESS_ERROR";

export const RECONNECT_BEGIN = "RECONNECT_BEGIN";
export const RECONNECT_SUCCESS = "RECONNECT_SUCCESS";
export const RECONNECT_ERROR = "RECONNECT_ERROR";

export const SIGN_TXN_BEGIN = "SIGN_TXN_BEGIN";
export const SIGN_TXN_SUCCESS = "SIGN_TXN_SUCCESS";
export const SIGN_TXN_ERROR = "SIGN_TXN_ERROR";
